module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.fa2772327f55d8198301.woff";


//////////////////
// WEBPACK FOOTER
// G:/UTL/BMI/Admin/Admin-ANG/src/assets/fonts/bootstrap/glyphicons-halflings-regular.woff
// module id = ../../../../../src/assets/fonts/bootstrap/glyphicons-halflings-regular.woff
// module chunks = styles